// components/home/Doctors.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaUserMd, FaClock } from 'react-icons/fa';

const Doctors = () => {
    const doctors = [
        {
            name: "Dr. Asrat Ergena",
            image: "/assets/doctor1.jpg"
        },
        {
            name: "Dr. Asrat Ergena",
            image: "/assets/doctor2.jpg"
        },
        {
            name: "Dr. Asrat Ergena",
            image: "/assets/doctor3.jpg"
        },
        {
            name: "Dr. Asrat Ergena",
            image: "/assets/doctor4.jpg"
        }
    ];

    return (
        <section className="py-16 bg-gray-50">
            <div className="max-w-screen-xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="text-center mb-12"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Doctors</h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Meet our team of experienced medical professionals
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {doctors.map((doctor, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            whileHover={{ y: -10 }}
                            className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition duration-300"
                        >
                            <div className="p-6">
                                <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden border-4 border-blue-100">
                                    <img 
                                        src={doctor.image} 
                                        alt={doctor.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <button className="w-full bg-blue-50 text-blue-600 py-2 rounded-lg hover:bg-blue-100 transition duration-300 font-medium">
                                    Book Appointment
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Doctors;